









































import {
  defineComponent,
  ref,
  useContext,
  useFetch,
} from "@nuxtjs/composition-api";
import LazyHydrate from "vue-lazy-hydration";
import { useCache, CacheTagPrefix } from "@vue-storefront/cache";
import { CmsPage } from "~/modules/GraphQL/types";
import { getMetaInfo } from "~/helpers/getMetaInfo";
import { useContent, useImage } from "~/composables";
import LoadWhenVisible from "~/components/utils/LoadWhenVisible.vue";
import SfCategoryMenuCard from "~/modules/catalog/category/components/views/SfCategoryMenuCard.vue";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";

export default defineComponent({
  name: "HomePage",
  components: {
    LazyHydrate,
    LoadWhenVisible,
    NewProducts: () =>
      import(/* webpackPrefetch: true */ "~/components/NewProducts.vue"),
    SfCategoryMenuCard,
    SkeletonLoader
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup() {
    const { addTags } = useCache();
    const { loadPage } = useContent();
    const { app } = useContext();
    const { isDesktop } = app.$device;

    const page = ref<CmsPage | null>(null);
    const {
      imageSizes: { productCard: imageSize },
    } = useImage();
    const menuHome =ref([]);
    useFetch(async () => {
      page.value = await loadPage({ identifier: "home" });
      menuHome.value = [
        {
          name: "Abrasives & Diamond Tools",
          image: "https://m2.hhip.com/media/catalog/product/cache/372a64e761f00e3291557c1dcfd07991/2/4/2405-5276_2405-3875a.jpg",
          categoryUrlPath: "metalworking/abrasives-diamond-tools.html",
        },
        {
          name: "Cutting Tools - HSS & Solid Carbide",
          image: "https://m2.hhip.com/media/catalog/product/cache/3d5e0d3e9c2d9601eecd0a41a345c033/8/0/8000-0004_8000-0004_1.jpg",
          categoryUrlPath: "metalworking/cutting-tools-hss-solid-carbide.html",
        },
        {
          name: "Cutting Tools - Indexable Carbide & Tool Holders",
          image: "https://m2.hhip.com/media/catalog/product/cache/3d5e0d3e9c2d9601eecd0a41a345c033/5/8/5822-1700_5822-1700_20210920.jpg",
          categoryUrlPath:
            "metalworking/cutting-tools-indexable-carbide-tool-holders.html",
        },
        {
          name: "Air & Hand Tools",
          image: "https://m2.hhip.com/media/catalog/product/cache/3d5e0d3e9c2d9601eecd0a41a345c033/7/6/7609-0095_7609-0095.jpg",
          categoryUrlPath: "air-power-hand-tools.html",
        },
        {
          name: "Machine Tool Accessories",
          image: "https://m2.hhip.com/media/catalog/product/cache/3d5e0d3e9c2d9601eecd0a41a345c033/3/9/3901-5101_3901-5101_20170614.jpg",
          categoryUrlPath: "machine-tool-accessories.html",
        },
        {
          name: "Precision",
          image: "https://m2.hhip.com/media/catalog/product/cache/3d5e0d3e9c2d9601eecd0a41a345c033/2/2/2210-8250_2210-8250_b_2022.01.21.jpg",
          categoryUrlPath: "precision.html",
        },
        {
          name: "Sheet Metal Equipment",
          image: "https://m2.hhip.com/media/catalog/product/cache/3d5e0d3e9c2d9601eecd0a41a345c033/8/6/8600-4032_8600-4032_201808.jpg",
          categoryUrlPath: "sheet-metal-equipment.html",
        },
        {
          name: "Shop Supplies",
          image: "https://m2.hhip.com/media/catalog/product/cache/3d5e0d3e9c2d9601eecd0a41a345c033/8/4/8401-0449_8401-0448a11722.jpg",
          categoryUrlPath: "shop-safety-welding-supplies.html",
        },
      ]
      addTags([{ prefix: CacheTagPrefix.View, value: "home" }]);
    });
    // @ts-ignore
    return {
      page,
      imageSize,
      menuHome
    };
  },
  head() {
    return getMetaInfo(this.page);
  }
});
